import React from "react";

export default function ReviewFeesDetails(props) {
  const getLabelText = (count) => {
    if (props.type === 2) {
      // Counselling usually sounds better as "Session(s)"
      return count > 1 ? "Counselling Sessions" : "Counselling Session";
    }
    return count > 1 ? "Mock Interviews" : "Mock Interview";
  };

  return (
    <section className="StepOne">
      <div className="row box">
        <div className="col-md-12">
          <p className="StepTitle">
            {props.type === 2 ? "Counselling " : ""}Fees
          </p>

          <div className="row">
            {props.feesDetails.map((item, index) => (
              <div
                className="col-lg-6 col-md-6 col-sm-12 mb-3"
                key={index}
              >
                <div className="forms">
                  <label className="form-label text-muted mt-2">
                    Fees for {item.fees_count} {getLabelText(item.fees_count)}
                  </label>

                  <span className="ReviewLabel">
                    ₹ {item.fees}
                  </span>
                </div>
              </div>
            ))}
          </div>
      </div>
    </div>
  </section>
  )
}
